import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TopSearchMobileDialogConfig } from '@/new-top-search/top-search.config';

@Component({
	selector: 'app-top-search-filter-items-mobile',
	templateUrl: './top-search-filter-items-mobile.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'flex h-full min-h-0 flex-1 flex-col overflow-hidden',
	},
})
export class TopSearchFilterItemsMobileComponent {
	readonly filters = TopSearchMobileDialogConfig;
}
